import { Mail } from "lucide-react";

const CONTACT_EMAIL = "hola@matronaia.com";

export default function Contact() {
    return (
        <div data-testid="contact-page">
            <section className="max-w-3xl mx-auto px-6 sm:px-8 py-20 sm:py-28">
                <div className="text-center">
                    <p className="eyebrow">Hablemos</p>
                    <h1 className="headline mt-4 text-4xl sm:text-5xl">
                        Estamos
                        <em className="italic text-[#b7677a] font-light">
                            {" "}
                            cerca.
                        </em>
                    </h1>
                    <p className="mt-6 text-[#5c5450] leading-relaxed max-w-xl mx-auto">
                        ¿Tienes alguna pregunta, sugerencia o necesitas ayuda
                        con Matrona IA? Escríbenos. Leemos cada mensaje con
                        atención.
                    </p>
                </div>

                <div className="mt-14 paper rounded-3xl border border-[#e8dcc8]/70 px-7 sm:px-12 py-12 text-center shadow-[0_20px_60px_-30px_rgba(45,42,40,0.15)]">
                    <div
                        className="inline-flex items-center justify-center w-14 h-14 rounded-full mb-6"
                        style={{
                            background:
                                "linear-gradient(135deg, #f4dee2 0%, #fdfaf6 100%)",
                        }}
                    >
                        <Mail
                            size={22}
                            className="text-[#b7677a]"
                            strokeWidth={1.5}
                        />
                    </div>

                    <p className="eyebrow">Escríbenos a</p>
                    <a
                        href={`mailto:${CONTACT_EMAIL}`}
                        data-testid="contact-email-link"
                        className="block mt-3 font-serif text-2xl sm:text-3xl text-[#b7677a] hover:text-[#9a4f63] transition-colors duration-500 break-all"
                    >
                        {CONTACT_EMAIL}
                    </a>

                    <p className="mt-8 text-[0.92rem] text-[#8a807b] italic">
                        Respondemos en cuanto nos es posible, siempre con el
                        mayor cuidado.
                    </p>

                    <a
                        href={`mailto:${CONTACT_EMAIL}`}
                        data-testid="contact-email-button"
                        className="pill-primary btn-soft-shadow inline-flex items-center gap-2 mt-10 px-7 py-3.5"
                    >
                        <Mail size={18} />
                        Enviar un correo
                    </a>
                </div>
            </section>
        </div>
    );
}
